var React = require('react');

function CollapseLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.944 25.5l6.074 6.073a1.49 1.49 0 01-.008 2.114 1.498 1.498 0 01-2.12 0l-8.628-8.626a1.472 1.472 0 01-.325-.495c-.003-.004-.003-.007-.003-.01 0-.005 0-.008-.004-.012a1.385 1.385 0 01-.106-.544 1.29 1.29 0 01.106-.544c.004-.004.004-.008.004-.011 0-.004 0-.007.003-.01.078-.192.184-.354.325-.496l8.634-8.633a1.505 1.505 0 012.122 0 1.498 1.498 0 010 2.12l-6.075 6.075h23.745a1.49 1.49 0 011.5 1.499 1.49 1.49 0 01-1.5 1.5H19.944zM2.813 1.5a1.5 1.5 0 113 0v45a1.5 1.5 0 01-3 0v-45z"}));
}

CollapseLeft.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = CollapseLeft;

CollapseLeft.default = CollapseLeft;
